/**
 * @generated SignedSource<<b9c7354c69be3b347d84955aa12a6686>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueResults_rankField$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_ListView_rankField">;
  readonly " $fragmentType": "main_issueNavigator_IssueResults_rankField";
};
export type main_issueNavigator_IssueResults_rankField$key = {
  readonly " $data"?: main_issueNavigator_IssueResults_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueResults_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_IssueResults_rankField",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_ListView_rankField"
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "6841e7e8e6eb501774888d028077731e";

export default node;
